import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import AuthStatusScreen from './AuthStatusScreen';
import { handleExpiredSession, resetSessionExpiryHandling } from '../../auth/getToken';

function AfterLogin() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const handleRedirectResult = async () => {
      try {
        console.log("AfterLogin - Starting redirect result handling...");
        
        // Handle the redirect result
        const redirectResult = await instance.handleRedirectPromise();
        // Nie das Ergebnisobjekt ausgeben: Es enthaelt Access- und ID-Token.
        console.log("Redirect-Ergebnis vorhanden:", Boolean(redirectResult));
        
        if (redirectResult) {
          console.log("Login successful, account:", redirectResult.account?.username);
          instance.setActiveAccount(redirectResult.account);
        }
        
        // Wait a bit for MSAL to process everything
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        const accounts = instance.getAllAccounts();
        console.log("AfterLogin - Available accounts after redirect:", accounts.length);
        
        if (accounts.length > 0) {
          const account = accounts[0];
          console.log("Setting active account:", account.username);
          instance.setActiveAccount(account);

          const request = {
            scopes: ["User.Read"],
            account: account,
          };

          try {
            await instance.acquireTokenSilent(request);
            console.log("Stille Token-Akquise erfolgreich.");
            resetSessionExpiryHandling();

            // Navigiere zur Hauptseite (UserView)
            navigate('/');
          } catch (error) {
            console.error("Fehler bei der stillen Token-Akquise:", error);
            await handleExpiredSession(instance);
          }
        } else {
          console.error("Keine Konten nach Login gefunden!");
          // Zurück zum Login
          navigate('/login');
        }
      } catch (error) {
        console.error("Error in AfterLogin:", error);
        navigate('/login');
      } finally {
        setIsProcessing(false);
      }
    };

    handleRedirectResult();
  }, [instance, navigate]);

  if (isProcessing) {
    return (
      <AuthStatusScreen
        title="Anmeldung wird abgeschlossen"
        subtitle="Dein Konto wird geprüft und die Anwendung wird vorbereitet."
      />
    );
  }

  return (
    <AuthStatusScreen
      title="Weiterleitung"
      subtitle="Du wirst jetzt zur Startseite weitergeleitet."
    />
  );
}

export default AfterLogin;
